import { IconType } from 'react-icons';
import * as AI from 'react-icons/ai'; //MIT
import * as BI from 'react-icons/bi'; //MIT
import * as BS from 'react-icons/bs'; // MIT
import * as FA from 'react-icons/fa'; // CC 4.0 https://creativecommons.org/licenses/by/4.0/
import * as FA6 from 'react-icons/fa6'; // CC 4.0 https://creativecommons.org/licenses/by/4.0/
import * as Fi from 'react-icons/fi';
import * as GI from 'react-icons/gi'; // CC 3.0 https://creativecommons.org/licenses/by/3.0/
import * as HI from 'react-icons/hi'; // MIT
import * as IO from 'react-icons/io'; // MIT
import * as IO5 from 'react-icons/io5'; // MIT
import * as MD from 'react-icons/md'; // Apache 2
import * as PI from 'react-icons/pi'; //MIT
import * as RI from 'react-icons/ri'; // Apache 2
import * as TB from 'react-icons/tb';

import { DropdownOption } from '@/components/grid/GridSelect';
import { IconCategory } from '../services/tasks/task.types';

export const getOption = (optionsArray: DropdownOption[], optionId: any) => {
  if (optionsArray && optionId) {
    return optionsArray.find(opt => opt.id === optionId);
  }
};

export enum IconLineType {
  STROKE = 1,
  FILL = 2,
  TEXT = 3
}

export const getIconArrayByCategory = (category: IconCategory) => {
  switch (category) {
    case IconCategory.standard:
      return standardIconArray;
    case IconCategory.retail:
      return retailIconArray;
    case IconCategory.hospitality:
      return hospitalityIconArray;
    default:
      return [];
  }
};

export interface Icon {
  id: string;
  name: string;
  value: IconType;
  svgPaths: string[];
  svgViewboxSize: number;
  type: IconLineType;
}

export const standardIconArray: Icon[] = [
  {
    id: '1',
    value: Fi.FiClipboard,
    name: 'Clipboard',
    svgPaths: ['M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2'],
    svgViewboxSize: 16,
    type: IconLineType.FILL
  },
  {
    id: '2',
    value: IO.IoMdLock,
    name: 'Lock',
    svgPaths: [
      'M368,192H352V112a96,96,0,1,0-192,0v80H144a64.07,64.07,0,0,0-64,64V432a64.07,64.07,0,0,0,64,64H368a64.07,64.07,0,0,0,64-64V256A64.07,64.07,0,0,0,368,192Zm-48,0H192V112a64,64,0,1,1,128,0Z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '3',
    value: BI.BiSolidShow,
    name: 'Bell',
    svgPaths: [
      'M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 11c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z',
      'M12 10c-1.084 0-2 .916-2 2s.916 2 2 2 2-.916 2-2-.916-2-2-2z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '4',
    value: RI.RiLeafFill,
    name: 'Leaf',
    svgPaths: [
      'M20.998 3V5C20.998 14.6274 15.6255 19 8.99805 19L7.0964 18.9999C7.3079 15.9876 8.24541 14.1648 10.6939 11.9989C11.8979 10.9338 11.7965 10.3189 11.2029 10.6721C7.1193 13.1016 5.09114 16.3862 5.00119 21.6302L4.99805 22H2.99805C2.99805 20.6373 3.11376 19.3997 3.34381 18.2682C3.1133 16.9741 2.99805 15.2176 2.99805 13C2.99805 7.47715 7.4752 3 12.998 3C14.998 3 16.998 4 20.998 3Z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '5',
    value: MD.MdFace,
    name: 'Face',
    svgPaths: [
      'M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '6',
    value: BS.BsFillBookmarkFill,
    name: 'Bookmark',
    svgPaths: ['M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2'],
    svgViewboxSize: 16,
    type: IconLineType.FILL
  },
  {
    id: '7',
    value: BS.BsHeart,
    name: 'Heart',
    svgPaths: [
      'm8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15'
    ],
    svgViewboxSize: 16,
    type: IconLineType.FILL
  },
  {
    id: '8',
    value: BS.BsFillBagFill,
    name: 'Bag',
    svgPaths: [
      'M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1m3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4z'
    ],
    svgViewboxSize: 16,
    type: IconLineType.FILL
  },
  {
    id: '9',
    value: BI.BiSearchAlt2,
    name: 'Search',
    svgPaths: [
      'M19.023 16.977a35.13 35.13 0 0 1-1.367-1.384c-.372-.378-.596-.653-.596-.653l-2.8-1.337A6.962 6.962 0 0 0 16 9c0-3.859-3.14-7-7-7S2 5.141 2 9s3.14 7 7 7c1.763 0 3.37-.66 4.603-1.739l1.337 2.8s.275.224.653.596c.387.363.896.854 1.384 1.367l1.358 1.392.604.646 2.121-2.121-.646-.604c-.379-.372-.885-.866-1.391-1.36zM9 14c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '10',
    value: AI.AiFillTool,
    name: 'Tool',
    svgPaths: [
      'M865.3 244.7c-.3-.3-61.1 59.8-182.1 180.6l-84.9-84.9 180.9-180.9c-95.2-57.3-217.5-42.6-296.8 36.7A244.42 244.42 0 0 0 419 432l1.8 6.7-283.5 283.4c-6.2 6.2-6.2 16.4 0 22.6l141.4 141.4c6.2 6.2 16.4 6.2 22.6 0l283.3-283.3 6.7 1.8c83.7 22.3 173.6-.9 236-63.3 79.4-79.3 94.1-201.6 38-296.6z'
    ],
    svgViewboxSize: 1024,
    type: IconLineType.FILL
  },
  {
    id: '11',
    value: HI.HiPhone,
    name: 'Phone',
    svgPaths: [
      'M1.5 4.5C1.5 2.84315 2.84315 1.5 4.5 1.5H5.87163C6.732 1.5 7.48197 2.08556 7.69064 2.92025L8.79644 7.34343C8.97941 8.0753 8.70594 8.84555 8.10242 9.29818L6.8088 10.2684C6.67447 10.3691 6.64527 10.5167 6.683 10.6197C7.81851 13.7195 10.2805 16.1815 13.3803 17.317C13.4833 17.3547 13.6309 17.3255 13.7316 17.1912L14.7018 15.8976C15.1545 15.2941 15.9247 15.0206 16.6566 15.2036L21.0798 16.3094C21.9144 16.518 22.5 17.268 22.5 18.1284V19.5C22.5 21.1569 21.1569 22.5 19.5 22.5H17.25C8.55151 22.5 1.5 15.4485 1.5 6.75V4.5Z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '12',
    value: BS.BsFillQuestionSquareFill,
    name: 'Question',
    svgPaths: [
      'M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm3.496 6.033a.237.237 0 0 1-.24-.247C5.35 4.091 6.737 3.5 8.005 3.5c1.396 0 2.672.73 2.672 2.24 0 1.08-.635 1.594-1.244 2.057-.737.559-1.01.768-1.01 1.486v.105a.25.25 0 0 1-.25.25h-.81a.25.25 0 0 1-.25-.246l-.004-.217c-.038-.927.495-1.498 1.168-1.987.59-.444.965-.736.965-1.371 0-.825-.628-1.168-1.314-1.168-.803 0-1.253.478-1.342 1.134-.018.137-.128.25-.266.25h-.825zm2.325 6.443c-.584 0-1.009-.394-1.009-.927 0-.552.425-.94 1.01-.94.609 0 1.028.388 1.028.94 0 .533-.42.927-1.029.927z'
    ],
    svgViewboxSize: 16,
    type: IconLineType.FILL
  },
  {
    id: '13',
    value: BI.BiSolidMoon,
    name: 'Moon',
    svgPaths: [
      'M12 11.807A9.002 9.002 0 0 1 10.049 2a9.942 9.942 0 0 0-5.12 2.735c-3.905 3.905-3.905 10.237 0 14.142 3.906 3.906 10.237 3.905 14.143 0a9.946 9.946 0 0 0 2.735-5.119A9.003 9.003 0 0 1 12 11.807z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '14',
    value: RI.RiCupFill,
    name: 'Cup',
    svgPaths: [
      'M5 3H20C21.1046 3 22 3.89543 22 5V8C22 9.10457 21.1046 10 20 10H18V13C18 15.2091 16.2091 17 14 17H8C5.79086 17 4 15.2091 4 13V4C4 3.44772 4.44772 3 5 3ZM18 5V8H20V5H18ZM2 19H20V21H2V19Z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '15',
    value: MD.MdCake,
    name: 'Cake',
    svgPaths: [
      'M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '16',
    value: IO.IoMdStar,
    name: 'Star',
    svgPaths: [
      'M394,480a16,16,0,0,1-9.39-3L256,383.76,127.39,477a16,16,0,0,1-24.55-18.08L153,310.35,23,221.2A16,16,0,0,1,32,192H192.38l48.4-148.95a16,16,0,0,1,30.44,0l48.4,149H480a16,16,0,0,1,9.05,29.2L359,310.35l50.13,148.53A16,16,0,0,1'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '18',
    value: BS.BsTicket,
    name: 'Ticket',
    svgPaths: [
      'M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5V6a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .5.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5V10a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0 0-3A.5.5 0 0 1 0 6zM1.5 4a.5.5 0 0 0-.5.5v1.05a2.5 2.5 0 0 1 0 4.9v1.05a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-1.05a2.5 2.5 0 0 1 0-4.9V4.5a.5.5 0 0 0-.5-.5z'
    ],
    svgViewboxSize: 16,
    type: IconLineType.FILL
  },
  {
    id: '19',
    value: RI.RiKeyFill,
    name: 'Key',
    svgPaths: [
      'M17 14H12.6586C11.8349 16.3304 9.61244 18 7 18C3.68629 18 1 15.3137 1 12C1 8.68629 3.68629 6 7 6C9.61244 6 11.8349 7.66962 12.6586 10H23V14H21V18H17V14ZM7 14C8.10457 14 9 13.1046 9 12C9 10.8954 8.10457 10 7 10C5.89543 10 5 10.8954 5 12C5 13.1046 5.89543 14 7 14Z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '20',
    value: MD.MdOutlineLightbulb,
    name: 'Light bulb',
    svgPaths: [
      'M9 21c0 .5.4 1 1 1h4c.6 0 1-.5 1-1v-1H9v1zm3-19C8.1 2 5 5.1 5 9c0 2.4 1.2 4.5 3 5.7V17c0 .5.4 1 1 1h6c.6 0 1-.5 1-1v-2.3c1.8-1.3 3-3.4 3-5.7 0-3.9-3.1-7-7-7z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '21',
    value: MD.MdStore,
    name: 'Store',
    svgPaths: ['M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z'],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '24',
    value: MD.MdOutdoorGrill,
    name: 'Grill',
    svgPaths: [
      'M17,22c1.66,0,3-1.34,3-3s-1.34-3-3-3c-1.3,0-2.4,0.84-2.82,2H9.14l1.99-3.06C11.42,14.98,11.71,15,12,15 s0.58-0.02,0.87-0.06l1.02,1.57c0.42-0.53,0.96-0.95,1.6-1.21l-0.6-0.93C17.31,13.27,19,10.84,19,8H5c0,2.84,1.69,5.27,4.12,6.37 l-3.95,6.08c-0.3,0.46-0.17,1.08,0.29,1.38h0c0.46,0.3,1.08,0.17,1.38-0.29l1-1.55h6.34C14.6,21.16,15.7,22,17,22z M17,18 c0.55,0,1,0.45,1,1c0,0.55-0.45,1-1,1s-1-0.45-1-1C16,18.45,16.45,18,17,18z"/>path d="M9.41,7h1c0.15-1.15,0.23-1.64-0.89-2.96C9.1,3.54,8.84,3.27,9.06,2H8.07C7.86,3.11,8.1,4.05,8.96,4.96 C9.18,5.2,9.75,5.63,9.41,7z"/>path d="M11.89,7h1c0.15-1.15,0.23-1.64-0.89-2.96c-0.42-0.5-0.68-0.78-0.46-2.04h-0.99c-0.21,1.11,0.03,2.05,0.89,2.96 C11.67,5.2,12.24,5.63,11.89,7z"/>path d="M14.41,7h1c0.15-1.15,0.23-1.64-0.89-2.96C14.1,3.54,13.84,3.27,14.06,2h-0.99c-0.21,1.11,0.03,2.05,0.89,2.96 C14.18,5.2,14.75,5.63,14.41,7z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '28',
    value: BS.BsCash,
    name: 'Cash',
    svgPaths: [
      'M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4',
      'M0 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V6a2 2 0 0 1-2-2z'
    ],
    svgViewboxSize: 16,
    type: IconLineType.FILL
  },
  {
    id: '29',
    value: BS.BsPersonVcardFill,
    name: 'Person card',
    svgPaths: [
      'M5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8m1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5',
      'M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.96c.026-.163.04-.33.04-.5C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1.006 1.006 0 0 1 1 12z'
    ],
    svgViewboxSize: 16,
    type: IconLineType.FILL
  },
  {
    id: '30',
    value: MD.MdReceipt,
    name: 'Receipt',
    svgPaths: [
      'M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '31',
    value: PI.PiAirplane,
    name: 'Airplane',
    svgPaths: ['M16 10h4a2 2 0 0 1 0 4h-4l-4 7h-3l2 -7h-4l-2 2h-3l2 -4l-2 -4h3l2 2h4l-2 -7h3z'],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '32',
    value: MD.MdWaterDrop,
    name: 'Chemical',
    svgPaths: [
      'M12,2c-5.33,4.55-8,8.48-8,11.8c0,4.98,3.8,8.2,8,8.2s8-3.22,8-8.2C20,10.48,17.33,6.55,12,2z M7.83,14 c0.37,0,0.67,0.26,0.74,0.62c0.41,2.22,2.28,2.98,3.64,2.87c0.43-0.02,0.79,0.32,0.79,0.75c0,0.4-0.32,0.73-0.72,0.75 c-2.13,0.13-4.62-1.09-5.19-4.12C7.01,14.42,7.37,14,7.83,14z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '33',
    value: PI.PiAlarm,
    name: 'Alarm',
    svgPaths: ['M12 13m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0', 'M12 10l0 3l2 0', 'M7 4l-2.75 2', 'M17 4l2.75 2'],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '34',
    value: PI.PiDress,
    name: 'Dress',
    svgPaths: [
      'M200,224a8,8,0,0,0,7.35-11.15L160,112l22.86-35.88a8,8,0,0,0,0-8.24L160,35.22,153,44a32,32,0,0,1-50,0l-7-8.77L73.14,67.88a8,8,0,0,0,0,8.24L96,112,48.66,212.85A8,8,0,0,0,56,224Z'
    ],
    svgViewboxSize: 256,
    type: IconLineType.FILL
  },
  {
    id: '35',
    value: IO.IoIosBeer,
    name: 'Beer',
    svgPaths: [
      'M392,208H368v-5.74A63.93,63.93,0,0,0,321.65,96a111,111,0,0,0-27.59-47.29A108.62,108.62,0,0,0,216,16c-29.91,0-57.78,12.28-79,34.68a56,56,0,0,0-67.51,77.54A63.91,63.91,0,0,0,80,231.39V440a56.06,56.06,0,0,0,56,56H312a56.06,56.06,0,0,0,56-56v-8h24a72.08,72.08,0,0,0,72-72V280A72.08,72.08,0,0,0,392,208ZM176,416a16,16,0,0,1-32,0V256a16,16,0,0,1,32,0Zm64,0a16,16,0,0,1-32,0V256a16,16,0,0,1,32,0Zm64,0a16,16,0,0,1-32,0V256a16,16,0,0,1,32,0Zm16-224c-8.33,0-20.55-5.18-26.69-11.31A16,16,0,0,0,282,176H160a16,16,0,0,0-15,10.53C138.17,205.21,121.4,208,112,208a32,32,0,0,1,0-64c.09,0,9.12.34,16.4,5.8a16,16,0,1,0,19.2-25.6A63.69,63.69,0,0,0,112,112a63.55,63.55,0,0,0-14,1.57A24,24,0,0,1,120,80a23.78,23.78,0,0,1,19.38,9.84,51.35,51.35,0,0,1,4.71,7.9A16,16,0,0,0,176,96c0-6.77-3.61-15.17-10.76-25-.46-.63-1-1.25-1.45-1.86C178.39,55.44,196.64,48,216,48a76.86,76.86,0,0,1,55.23,23.18A80.2,80.2,0,0,1,292.61,142a16,16,0,0,0,12.73,18.71,16.29,16.29,0,0,0,3,.28,16,16,0,0,0,15.7-13A111.78,111.78,0,0,0,326,128.57,32,32,0,0,1,320,192ZM432,360a40,40,0,0,1-40,40H368V240h24a40,40,0,0,1,40,40Z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '38',
    value: MD.MdSanitizer,
    name: 'Sanitize',
    svgPaths: [
      'M15.5,6.5C15.5,5.66,17,4,17,4s1.5,1.66,1.5,2.5C18.5,7.33,17.83,8,17,8S15.5,7.33,15.5,6.5z M19.5,15 c1.38,0,2.5-1.12,2.5-2.5c0-1.67-2.5-4.5-2.5-4.5S17,10.83,17,12.5C17,13.88,18.12,15,19.5,15z M13,14h-2v-2H9v2H7v2h2v2h2v-2h2V14z M16,12v10H4V12c0-2.97,2.16-5.43,5-5.91V4H7V2h6c1.13,0,2.15,0.39,2.99,1.01l-1.43,1.43C14.1,4.17,13.57,4,13,4h-2v2.09 C13.84,6.57,16,9.03,16,12z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '39',
    value: BI.BiSolidWasher,
    name: 'Washer',
    svgPaths: [
      'M4 22h16a1 1 0 0 0 1-1V5c0-1.654-1.346-3-3-3H6C4.346 2 3 3.346 3 5v16a1 1 0 0 0 1 1zM18 3.924a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM12 7c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z',
      'M12.766 16.929c1.399-.261 2.571-1.315 3.023-2.665a3.853 3.853 0 0 0-.153-2.893.482.482 0 0 0-.544-.266c-.604.149-1.019.448-1.5.801-.786.577-1.765 1.294-3.592 1.294-.813 0-1.45-.146-1.984-.354l-.013.009a4.006 4.006 0 0 0 4.763 4.074z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '40',
    value: MD.MdCleaningServices,
    name: 'Cleaner',
    svgPaths: [
      'M16,11h-1V3c0-1.1-0.9-2-2-2h-2C9.9,1,9,1.9,9,3v8H8c-2.76,0-5,2.24-5,5v7h18v-7C21,13.24,18.76,11,16,11z M19,21h-2v-3 c0-0.55-0.45-1-1-1s-1,0.45-1,1v3h-2v-3c0-0.55-0.45-1-1-1s-1,0.45-1,1v3H9v-3c0-0.55-0.45-1-1-1s-1,0.45-1,1v3H5v-5 c0-1.65,1.35-3,3-3h8c1.65,0,3,1.35,3,3V21z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  }
];

export const retailIconArray: Icon[] = [
  {
    id: '1',
    value: PI.PiBuildingsThin,
    name: 'BuildingThin',
    svgPaths: [
      'M240,212H220V96a12,12,0,0,0-12-12H140V32a12,12,0,0,0-18.66-10l-80,53.33a12,12,0,0,0-5.34,10V212H16a4,4,0,0,0,0,8H240a4,4,0,0,0,0-8ZM208,92a4,4,0,0,1,4,4V212H140V92ZM44,85.34A4,4,0,0,1,45.78,82l80-53.33A4,4,0,0,1,132,32V212H44ZM108,112v16a4,4,0,0,1-8,0V112a4,4,0,0,1,8,0Zm-32,0v16a4,4,0,0,1-8,0V112a4,4,0,0,1,8,0Zm0,56v16a4,4,0,0,1-8,0V168a4,4,0,0,1,8,0Zm32,0v16a4,4,0,0,1-8,0V168a4,4,0,0,1,8,0Z'
    ],
    svgViewboxSize: 256,
    type: IconLineType.FILL
  },
  {
    id: '2',
    value: IO5.IoStorefrontSharp,
    name: 'StoreFrontSharp',
    svgPaths: [
      'M464 448V267.85a104.76 104.76 0 0 1-33.56 6.58c-1.18 0-2.3.05-3.4.05a108 108 0 0 1-56.86-16 108 108 0 0 1-56.85 16 106.16 106.16 0 0 1-56.51-16.2 107.84 107.84 0 0 1-57.2 16.2 106.14 106.14 0 0 1-56.85-16.42 106.14 106.14 0 0 1-56.85 16.42c-1.09 0-2.19 0-3.37-.05h-.06A104.66 104.66 0 0 1 48 267.49V448H16v32h480v-32zm-240-64h-96v-76a4 4 0 0 1 4-4h88a4 4 0 0 1 4 4zm160 64h-80V308a4 4 0 0 1 4-4h72a4 4 0 0 1 4 4zm108.57-277.72L445.89 64C432 32 432 32 400 32H112c-32 0-32 0-45.94 32L19.38 170.28c-9 19.41 2.89 39.34 2.9 39.35l.41.66c.42.66 1.13 1.75 1.62 2.37.1.13.19.27.28.4l5.24 6.39 5.31 5.14.42.36a69.65 69.65 0 0 0 9.44 6.78v.05a74 74 0 0 0 36 10.67h2.47a76.08 76.08 0 0 0 51.89-20.31 72.38 72.38 0 0 0 5.77-6 74.18 74.18 0 0 0 5.78 6 76.08 76.08 0 0 0 51.89 20.31c23.28 0 44.07-10 57.63-25.56a.11.11 0 0 1 .15 0l5.66 5.26a76.09 76.09 0 0 0 51.9 20.31c23.29 0 44.11-10 57.66-25.61 13.56 15.61 34.37 25.61 57.67 25.61h2.49a71.35 71.35 0 0 0 35-10.7c.95-.57 1.86-1.17 2.78-1.77A71.33 71.33 0 0 0 488 212.17l2-3c.9-2.04 11.21-20.3 2.57-38.89z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '3',
    value: MD.MdLocalGroceryStore,
    name: 'LocalGroceryStore',
    svgPaths: [
      'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 20 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '4',
    value: MD.MdOutlineLocalGroceryStore,
    name: 'OutlineLocalGroceryStore',
    svgPaths: [
      'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-1.45-5c.75 0 1.41-.41 1.75-1.03l3.58-6.49A.996.996 0 0 0 20.01 4H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '5',
    value: PI.PiStorefrontBold,
    name: 'StoreFrontBold',
    svgPaths: [
      'M236,96a12,12,0,0,0-.44-3.3L221.2,42.51A20.08,20.08,0,0,0,202,28H54A20.08,20.08,0,0,0,34.8,42.51L20.46,92.7A12,12,0,0,0,20,96h0v16a43.94,43.94,0,0,0,16,33.92V216a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V145.92A43.94,43.94,0,0,0,236,112V96ZM57.05,52H199l9.14,32H47.91Zm91,56v4a20,20,0,0,1-40,0v-4ZM53,128.71A20,20,0,0,1,44,112v-4H84v4a20,20,0,0,1-20,20,19.76,19.76,0,0,1-9.07-2.2A11.54,11.54,0,0,0,53,128.71ZM196,204H60V155.81c1.32.12,2.65.19,4,.19a43.86,43.86,0,0,0,32-13.85,43.89,43.89,0,0,0,64,0A43.86,43.86,0,0,0,192,156c1.35,0,2.68-.07,4-.19Zm16-92a20,20,0,0,1-9,16.71,11.66,11.66,0,0,0-1.88,1.09A20,20,0,0,1,172,112v-4h40Z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '6',
    value: FA.FaShoppingBag,
    name: 'ShoppingBag',
    svgPaths: [
      'M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '7',
    value: FA6.FaBasketShopping,
    name: 'ShoppingBasket',
    svgPaths: [
      'M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192 32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512L430 512c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32l-85.6 0L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192l-232.6 0L253.3 35.1zM192 304l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm128 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '8',
    value: FA6.FaShop,
    name: 'Shop',
    svgPaths: [
      'M36.8 192l566.3 0c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0L121.7 0c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM64 224l0 160 0 80c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-80 0-160-64 0 0 160-192 0 0-160-64 0zm448 0l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256-64 0z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '9',
    value: BI.BiSolidShoppingBags,
    name: 'ShoppingBags',
    svgPaths: [
      'M4 20h2V10a1 1 0 0 1 1-1h12V7a1 1 0 0 0-1-1h-3.051c-.252-2.244-2.139-4-4.449-4S6.303 3.756 6.051 6H3a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2zm6.5-16c1.207 0 2.218.86 2.45 2h-4.9c.232-1.14 1.243-2 2.45-2z',
      'M21 11H9a1 1 0 0 0-1 1v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a1 1 0 0 0-1-1zm-6 7c-2.757 0-5-2.243-5-5h2c0 1.654 1.346 3 3 3s3-1.346 3-3h2c0 2.757-2.243 5-5 5z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '10',
    value: MD.MdLocalPrintshop,
    name: 'LocalPrintShop',
    svgPaths: [
      'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '11',
    value: FA.FaBuilding,
    name: 'Building',
    svgPaths: [
      'M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '12',
    value: FA6.FaBuildingCircleArrowRight,
    name: 'BuildingCircleRight',
    svgPaths: [
      'M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 184.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512l-96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zM80 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352 432 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l89.4 0-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '13',
    value: FA6.FaBuildingColumns,
    name: 'BuildingColumns',
    svgPaths: [
      'M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160l0 8c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24l0-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224l-64 0 0 196.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512l448 0c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1L448 224l-64 0 0 192-40 0 0-192-64 0 0 192-48 0 0-192-64 0 0 192-40 0 0-192zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '14',
    value: FA6.FaBuildingFlag,
    name: 'Building Flag',
    svgPaths: [
      'M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM448 0c-17.7 0-32 14.3-32 32l0 480 64 0 0-320 144 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L480 32c0-17.7-14.3-32-32-32z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '15',
    value: RI.RiBuilding2Fill,
    name: 'Building2',
    svgPaths: [
      'M12 19H14V6.00003L20.3939 8.74028C20.7616 8.89786 21 9.2594 21 9.65943V19H23V21H1V19H3V5.6499C3 5.25472 3.23273 4.89659 3.59386 4.73609L11.2969 1.31251C11.5493 1.20035 11.8448 1.314 11.9569 1.56634C11.9853 1.63027 12 1.69945 12 1.76941V19Z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '16',
    value: BS.BsBuildingsFill,
    name: 'Buildings',
    svgPaths: [
      'M15 .5a.5.5 0 0 0-.724-.447l-8 4A.5.5 0 0 0 6 4.5v3.14L.342 9.526A.5.5 0 0 0 0 10v5.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V14h1v1.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zM2 11h1v1H2zm2 0h1v1H4zm-1 2v1H2v-1zm1 0h1v1H4zm9-10v1h-1V3zM8 5h1v1H8zm1 2v1H8V7zM8 9h1v1H8zm2 0h1v1h-1zm-1 2v1H8v-1zm1 0h1v1h-1zm3-2v1h-1V9zm-1 2h1v1h-1zm-2-4h1v1h-1zm3 0v1h-1V7zm-2-2v1h-1V5zm1 0h1v1h-1z'
    ],
    svgViewboxSize: 16,
    type: IconLineType.FILL
  },
  {
    id: '17',
    value: TB.TbBuildingBridge,
    name: 'BuildingBridge',
    svgPaths: [
      'M6 5l0 14',
      'M18 5l0 14',
      'M2 15l20 0',
      'M3 8a7.5 7.5 0 0 0 3 -2a6.5 6.5 0 0 0 12 0a7.5 7.5 0 0 0 3 2',
      'M12 10l0 5'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '18',
    value: TB.TbBuildingBroadcastTower,
    name: 'BuildingBroadcastTower',
    svgPaths: [
      'M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0',
      'M16.616 13.924a5 5 0 1 0 -9.23 0',
      'M20.307 15.469a9 9 0 1 0 -16.615 0',
      'M9 21l3 -9l3 9',
      'M10 19h4'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '19',
    value: TB.TbBuildingCastle,
    name: 'BuildingFlag',
    svgPaths: [
      'MM15 19v-2a3 3 0 0 0 -6 0v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14h4v3h3v-3h4v3h3v-3h4v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z',
      'M3 11l18 0'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '20',
    value: TB.TbBuildingPavilion,
    name: 'BuildingPavilion',
    svgPaths: [
      'M3 21h7v-3a2 2 0 0 1 4 0v3h7',
      'M6 21l0 -9',
      'M18 21l0 -9',
      'M6 12h12a3 3 0 0 0 3 -3a9 8 0 0 1 -9 -6a9 8 0 0 1 -9 6a3 3 0 0 0 3 3'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  }
];

export const hospitalityIconArray: Icon[] = [
  {
    id: '1',
    value: FA6.FaBowlFood,
    name: 'BowlFood',
    svgPaths: [
      'M0 192c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64c.5 0 1.1 0 1.6 0c35.3 0 64 28.7 64 64c0 11.7-3.1 22.6-8.6 32L8.6 224C3.1 214.6 0 203.7 0 192zm0 91.4C0 268.3 12.3 256 27.4 256l457.1 0c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28l-231.5 0c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '2',
    value: IO5.IoFastFood,
    name: 'FastFood',
    svgPaths: [
      'M368 128h.09m111.46-32h-91.06l8.92-35.66 38.32-13.05c8.15-2.77 13-11.43 10.65-19.71a16 16 0 0 0-20.54-10.73l-47 16a16 16 0 0 0-10.36 11.27L355.51 96H224.45c-8.61 0-16 6.62-16.43 15.23A16 16 0 0 0 224 128h2.75l1 8.66A8.3 8.3 0 0 0 236 144c39 0 73.66 10.9 100.12 31.52A121.9 121.9 0 0 1 371 218.07a123.4 123.4 0 0 1 10.12 29.51 7.83 7.83 0 0 0 3.29 4.88 72 72 0 0 1 26.38 86.43 7.92 7.92 0 0 0-.15 5.53A96 96 0 0 1 416 376c0 22.34-7.6 43.63-21.4 59.95a80.12 80.12 0 0 1-28.78 21.67 8 8 0 0 0-4.21 4.37 108.19 108.19 0 0 1-17.37 29.86 2.5 2.5 0 0 0 1.9 4.11h49.21a48.22 48.22 0 0 0 47.85-44.14L477.4 128h2.6a16 16 0 0 0 16-16.77c-.42-8.61-7.84-15.23-16.45-15.23z',
      'M108.69 320a23.87 23.87 0 0 1 17 7l15.51 15.51a4 4 0 0 0 5.66 0L162.34 327a23.87 23.87 0 0 1 17-7h196.58a8 8 0 0 0 8.08-7.92V312a40.07 40.07 0 0 0-32-39.2c-.82-29.69-13-54.54-35.51-72C295.67 184.56 267.85 176 236 176h-72c-68.22 0-114.43 38.77-116 96.8A40.07 40.07 0 0 0 16 312a8 8 0 0 0 8 8zm77.25 32a8 8 0 0 0-5.66 2.34l-22.14 22.15a20 20 0 0 1-28.28 0l-22.14-22.15a8 8 0 0 0-5.66-2.34h-69.4a15.93 15.93 0 0 0-15.76 13.17A65.22 65.22 0 0 0 16 376c0 30.59 21.13 55.51 47.26 56 2.43 15.12 8.31 28.78 17.16 39.47C93.51 487.28 112.54 496 134 496h132c21.46 0 40.49-8.72 53.58-24.55 8.85-10.69 14.73-24.35 17.16-39.47 26.13-.47 47.26-25.39 47.26-56a65.22 65.22 0 0 0-.9-10.83A15.93 15.93 0 0 0 367.34 352z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '3',
    value: MD.MdEmojiFoodBeverage,
    name: 'FoodBeverage',
    svgPaths: [
      'M20 3H9v2.4l1.81 1.45c.12.09.19.24.19.39v4.26c0 .28-.22.5-.5.5h-4c-.28 0-.5-.22-.5-.5V7.24c0-.15.07-.3.19-.39L8 5.4V3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2a2 2 0 0 0 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '4',
    value: MD.MdFastfood,
    name: 'FastFood2',
    svgPaths: [
      'M18.06 22.99h1.66c.84 0 1.53-.64 1.63-1.46L23 5.05h-5V1h-1.97v4.05h-4.97l.3 2.34c1.71.47 3.31 1.32 4.27 2.26 1.44 1.42 2.43 2.89 2.43 5.29v8.05zM1 21.99V21h15.03v.99c0 .55-.45 1-1.01 1H2.01c-.56 0-1.01-.45-1.01-1zm15.03-7c0-8-15.03-8-15.03 0h15.03zM1.02 17h15v2h-15z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '5',
    value: MD.MdFoodBank,
    name: 'FoodBank',
    svgPaths: [
      'M12 3 4 9v12h16V9l-8-6zm.5 9.5c0 .83-.67 1.5-1.5 1.5v4h-1v-4c-.83 0-1.5-.67-1.5-1.5v-3h1v3h.5v-3h1v3h.5v-3h1v3zM15 18h-1v-3.5h-1v-3c0-1.1.9-2 2-2V18z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '6',
    value: MD.MdNoFood,
    name: 'NoFood',
    svgPaths: [
      'M11.35 8.52 11 5h5V1h2v4h5l-1.38 13.79L11.35 8.52zM1 21v1c0 .55.45 1 1 1h13c.55 0 1-.45 1-1v-1H1zm20.9.9L2.1 2.1.69 3.51l5.7 5.7C3.28 9.87 1 11.99 1 15h11.17l2 2H1v2h15v-.17l4.49 4.49 1.41-1.42z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '7',
    value: GI.GiFoodChain,
    name: 'FoodChain',
    svgPaths: [
      'M316.5 70.25c-.72 6.95-1.734 13.736-3 20.344 12.315 10.112 23.644 22.72 33.375 38.53-12.47-9.09-25.16-14.98-38.28-18.405-1.58 5.215-3.355 10.31-5.376 15.25 8.883 4.326 17.547 9.732 25.874 16.436-11.392-1.21-22.253-1.648-32.844-1.72-2.29 4.25-4.795 8.353-7.5 12.345 37.188 5.378 74.36 17.742 111.03 37.376-.772-36.935-26.11-81.666-83.28-120.156zM15.47 93.125c8.837 10.885 16.473 22.046 22.686 33.53 23.477 5.784 47.696 16.287 72.03 34-21.74-6.466-41.183-7.49-59.5-4.436 2.955 9.607 4.9 19.456 5.752 29.56l28.406 8.126-28.125 11c-.637 12.014-2.822 24.396-6.69 37.188 10.02 2.278 20.572 2.518 31.97.28-13.162 9.942-26.297 16.16-39.22 19.657-3.955 9.28-8.777 18.785-14.53 28.5 55.874-11.275 92.37-27.547 113.47-46.03-6.286-3.173-12.748-6.244-19.407-9.25-8.642-3.9-15.25-8.45-19.72-14.375-4.47-5.925-6.265-13.815-4.343-20.75 3.844-13.87 17.296-22.617 35.78-29.53 6.17-2.31 12.36-4.42 18.564-6.345-22.876-33.16-75.31-61.603-137.125-71.125zm231.155 74.438c-49.666-.092-99.264 12.687-145.938 37.562 10.067 4.313 19.585 8.538 28.626 12.75.233.11.446.204.687.313 39.04 18.24 69.042 36.415 94.75 61.75l24.03-12.438 8.595 16.594L234 296.188c9.052 8.52 19.78 14.486 31.688 18.625-18.848 2.345-37.715 1.337-56.563-5.72l-22.438 11.626c31.974 17.63 71.257 20.563 97.25 5.28l9.47 16.094c-6.117 3.596-12.608 6.41-19.376 8.47 7.396 15.617 18.3 31.395 32.75 48.092 35.162 40.627 80.495 48.148 99.064 3.875-14.172 10.394-39.122 9.802-51.313 1.19-25.038-17.697-11.577-52.194 2.5-78.126 11.844-21.817 42-34.654 57.908-25.47 12.553 7.248 15.24 24.905 8.437 42.532 16.457-9.064 33.79-9.677 43.53.78 7.308 7.84 8.207 19.94 4.158 32.252 46.384-47.552 5.884-114.95-47.625-149.032-55.533-39.73-116.22-58.982-176.813-59.094zm145.563 63.75c.45-.02.892-.012 1.343 0 3.284.084 6.583.962 9.626 2.718 9.737 5.623 13.092 18.074 7.47 27.814-5.623 9.737-18.077 13.06-27.813 7.437-9.737-5.62-13.09-18.074-7.47-27.81 3.624-6.277 10.1-9.886 16.844-10.157zm68.187 163.875c-8.3 25.18-29.67 34.388-52.344 42l41.158 6.406c2.32 32.026 10.377 48.196 39.53 43.53 11.6-26.25.588-45.847-26.562-55.25l-1.78-36.687z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '8',
    value: GI.GiFoodTruck,
    name: 'FoodTruck',
    svgPaths: [
      'M267.2 25.08l-70 70.16c-7.7 7.66-7.3 16.86-2.4 26.96l2 4.3-3.1 2.9-23.6 22.3 21.7 21.6 22.2-23.7 2.9-3 4.2 1.9c10.7 5.3 20.6 5.7 27.7-1.4L319 76.85l-10.2-10.18-45.7 45.63-9.6-9.8L299 56.97l-10.9-11.03-45.5 45.7-9.7-9.7 45.5-45.69zM28.97 27.84c-5.73 9.12-6.61 20.83-3.32 34.58 3.87 16.32 13.68 35.22 27.41 53.08 27.35 35.8 50.04 48.1 86.84 54.8l2.4.4c13.6 16.1 27.2 32.1 40.8 48.2h37.1zM137 183.2l-37.74 35.7h49.64l9.7-10.3zM26.25 232.9v63.5l16.51-49.5H279.8l16.5 49.5v-63.5zm29.49 32l-10 30h45.04l10.02-30zm63.96 0l-10 30h42.6v-30zm50.6 0v30h42.6l-10-30zm51.4 0l10 30h45.1l-10-30zm92.6 1.8v188.2h79c4.2-18.2 20.6-32 40-32s35.8 13.8 40 32h15v-64l-56.2-14H328.3v-82H390l-6.9-15zM26.25 312.9v114.2l42.17 27.8h14.85c4.14-18.2 20.53-32 40.03-32 19.4 0 35.8 13.8 40 32h133v-142h-14v80H40.25v-80zm320.05 0v46h72.4l-23-46zm-281.05 19l16 16h16l16.05-16zm-8 27v18H265.3v-18zm66.05 82c-12.9 0-23.1 10.2-23.1 23s10.2 23 23.1 23c12.8 0 23-10.2 23-23s-10.2-23-23-23zm310 0c-12.8 0-23 10.2-23 23s10.2 23 23 23 23-10.2 23-23-10.2-23-23-23z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '9',
    value: GI.GiOpenedFoodCan,
    name: 'OpenedFoodCan',
    svgPaths: [
      'M373.344 38.504c-.43.009-18.834 14.371-18.834 14.371l-28.965-5.792c-.212.06-24.143 22.862-24.143 22.862l-25.648-1.539-15.46 16.824-28.073-.722-18.516 20.615-25.371 2.928-17.123 18.37-27.215 8.95-16.062 22.598-23.72 6.224L91.21 184.67l-21.152 11.289-7.401 21.78-23.668 13.95-3.076 23.899c14.712-5.336 28.468.705 38.951 8.4l25.725-15.97 34.922-5.55 30.017-27.085 45.21-5.291 32.97-29.707 32.682-8.178 20.254-26.588c10.445-5.84 25.525-9.99 38.857-15.558l9.799-24.895 28.314-10.77c.154-.168.32-.341.473-.51l3.082-18.761 20.486-15.564c.047-.123.094-.246.139-.368l-15.924-5.943zM256 207.496c-.236 0-.469.004-.705.004a863.75 863.75 0 0 1-8.63 5.045 851.824 851.824 0 0 1-24.214 13.402c10.941-.297 22.144-.45 33.549-.45 61.422 0 117.054 4.476 156.81 11.575 19.879 3.55 35.834 7.816 46.086 12.145 5.127 2.164 8.794 4.391 10.635 5.998.795.693 1.053 1.042 1.23 1.281-.177.24-.435.588-1.23 1.281-1.84 1.607-5.508 3.834-10.635 5.998-10.252 4.329-26.207 8.595-46.085 12.145-39.757 7.1-95.39 11.576-156.811 11.576-60.185 0-114.771-4.304-154.35-11.156-1.062.294-2.148.61-3.197.89-14.957 3.99-28.503 6.543-40.469 7.438 10.618 3.378 23.344 6.348 38.041 8.973 41.316 7.377 97.685 11.855 159.975 11.855 62.29 0 118.659-4.478 159.975-11.855 20.658-3.69 37.506-8.041 49.923-13.284 6.21-2.62 11.343-5.418 15.47-9.02 4.126-3.6 7.632-8.675 7.632-14.84 0-6.167-3.506-11.242-7.633-14.843-4.126-3.6-9.26-6.398-15.469-9.02-12.417-5.242-29.265-9.594-49.923-13.282-41.316-7.378-97.685-11.856-159.975-11.856zm224 80.926c-17.886 9.361-42.297 15.703-70.854 21.017-44.267 8.238-98.66 12.433-153.084 12.815-54.423.382-108.8-3.051-153.021-10.316-22.11-3.633-41.675-8.208-57.629-13.9-4.795-1.712-9.272-3.5-13.412-5.42v112.495c54.727 19.858 139.481 30.383 224 30.383s169.273-10.525 224-30.383zM23.354 421.135a16.182 16.182 0 0 0-.354 3.361c0 6.166 3.506 11.24 7.633 14.842 4.126 3.601 9.26 6.398 15.469 9.02 12.417 5.242 29.265 9.594 49.923 13.283 41.316 7.377 97.685 11.855 159.975 11.855 62.29 0 118.659-4.478 159.975-11.855 20.658-3.69 37.506-8.041 49.923-13.284 6.21-2.62 11.343-5.418 15.47-9.02 4.126-3.6 7.632-8.675 7.632-14.84 0-1.16-.125-2.282-.354-3.362-58.527 21.982-145.45 32.361-232.646 32.361s-174.119-10.38-232.646-32.361z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '10',
    value: BI.BiFoodMenu,
    name: 'FoodMenu',
    svgPaths: [
      'M3 2h2v20H3zm7 4h7v2h-7zm0 4h7v2h-7z',
      'M19 2H6v20h13c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 18H8V4h11v16z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '11',
    value: PI.PiBowlFood,
    name: 'FoodBowl',
    svgPaths: [
      'M224,104h-8.37a88,88,0,0,0-175.26,0H32a8,8,0,0,0-8,8,104.35,104.35,0,0,0,56,92.28V208a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-3.72A104.35,104.35,0,0,0,232,112,8,8,0,0,0,224,104Zm-24.46,0H148.12a71.84,71.84,0,0,1,41.27-29.57A71.45,71.45,0,0,1,199.54,104ZM173.48,56.23q2.75,2.25,5.27,4.75a87.92,87.92,0,0,0-49.15,43H100.1A72.26,72.26,0,0,1,168,56C169.83,56,171.66,56.09,173.48,56.23ZM128,40a71.87,71.87,0,0,1,19,2.57A88.36,88.36,0,0,0,83.33,104H56.46A72.08,72.08,0,0,1,128,40Zm36.66,152A8,8,0,0,0,160,199.3V208H96v-8.7A8,8,0,0,0,91.34,192a88.29,88.29,0,0,1-51-72H215.63A88.29,88.29,0,0,1,164.66,192Z'
    ],
    svgViewboxSize: 256,
    type: IconLineType.FILL
  },
  {
    id: '12',
    value: PI.PiBowlFoodFill,
    name: 'FoodBowlFill',
    svgPaths: [
      'M224,104h-8.37a88,88,0,0,0-175.26,0H32a8,8,0,0,0-8,8,104.35,104.35,0,0,0,56,92.28V208a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-3.72A104.35,104.35,0,0,0,232,112,8,8,0,0,0,224,104ZM173.48,56.23q2.75,2.25,5.27,4.75a87.92,87.92,0,0,0-49.15,43H100.1A72.26,72.26,0,0,1,168,56C169.83,56,171.66,56.09,173.48,56.23ZM148.12,104a71.84,71.84,0,0,1,41.27-29.57A71.45,71.45,0,0,1,199.54,104ZM128,40a71.87,71.87,0,0,1,19,2.57A88.36,88.36,0,0,0,83.33,104H56.46A72.08,72.08,0,0,1,128,40Z'
    ],
    svgViewboxSize: 256,
    type: IconLineType.FILL
  },
  {
    id: '13',
    value: MD.MdLocalDrink,
    name: 'LocalDrink',
    svgPaths: [
      'M0 0h24v24H0z',
      'm3 2 2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '14',
    value: MD.MdNoDrinks,
    name: 'NoDrink',
    svgPaths: [
      'M0 0h24v24H0z',
      'M5.83 3H21v2l-6.2 6.97L9.83 7h6.74l1.78-2H7.83l-2-2zm13.95 19.61L18 20.83V21H6v-2h5v-5l-1.37-1.54-8.24-8.24L2.8 2.81 3 3l18.19 18.19-1.41 1.42zM16.17 19 13 15.83V19h3.17z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '15',
    value: GI.GiDrinkMe,
    name: 'DrinkMe',
    svgPaths: [
      'M367.844 24.188c-2.995.07-5.916.408-8.688 1.03L343.72 56.657l-6.314-4.437-10.094-7.095-4.093 11.625-16.814 47.688-1.22 3.468.033.094c-22.914 35.49-54.143 58.155-88.75 75.094-42.497 20.8-89.883 32.402-131.25 47.094-22.233 7.895-36.518 24.47-42.72 44.28-6.202 19.81-5.122 42.612.594 65.657 11.43 46.09 41.39 93.763 78.625 119.938 37.233 26.174 92.217 38.243 139.468 33.406 23.625-2.42 45.452-9.12 62-21.658 16.547-12.538 27.34-31.594 27.25-55.187-.172-43.895-5.293-92.393-.094-139.406 4.3-38.89 15.366-76.49 41.906-110.47l1.28-1.063 15.75-12.843v90.97c-13.467 4.385-23.325 17.07-23.436 31.905-.512 4.607-.25 9.738 1.03 15.5l.032.124.03.125 22.377 117.31 67.718-22.5-22.874-119.75c-2.23-11.095-7.69-17.16-14.875-20.717-3.383-1.676-7.24-2.71-11.31-3.063V137.625l4.75-3.875 9.56-7.78-10.092-7.095-5.157-3.625 24.376-25.188c0-30.925-48.225-66.712-83.562-65.874zM336.75 74.594l74.594 52.47-1.47 1.186h-.593v.5l-24.342 19.813c-30.565-4.34-48.466-18.5-59.594-41.657l11.406-32.312zm-21.688 52.062c12.428 18.638 30.934 32.057 55.438 38.188-23.95 34.7-34.592 72.706-38.75 110.312-.167 1.512-.32 3.02-.47 4.53-6.62-4.037-16.198-8.078-27.936-11.56-26.956-8-65.25-13.157-107.53-13.157-42.282 0-80.546 5.156-107.5 13.155-11.706 3.473-21.257 7.505-27.876 11.53 4.798-14.994 14.042-25.84 31.03-31.874 40-14.204 88.293-25.884 133.22-47.874 33.82-16.553 65.86-39.264 90.375-73.25zm104.594 134.22c8.455 0 15.094 6.636 15.094 15.093 0 8.453-6.64 15.124-15.094 15.124s-15.125-6.67-15.125-15.125 6.672-15.095 15.126-15.095zM57.062 301.75c.2.144.355.29.563.438 6.575 4.613 17.21 9.406 30.688 13.406 26.955 8 65.22 13.156 107.5 13.156s80.575-5.156 107.53-13.156c10.82-3.21 19.756-6.927 26.282-10.656-.258 7.08-.352 14.132-.344 21.125-6.165 2.74-13.052 5.19-20.624 7.437-29.44 8.737-69.065 13.938-112.844 13.938-43.778 0-83.402-5.2-112.843-13.938-9.018-2.676-17.087-5.64-24.095-9.03-1.346-7.904-1.953-15.534-1.813-22.72z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '16',
    value: GI.GiDrinking,
    name: 'Drinking',
    svgPaths: [
      'M136.56 70.504a88.18 88.18 0 0 0-12.686.949c-33.833 5.004-62.022 29.192-80.272 65.89-18.25 36.699-26.008 85.566-18.285 137.307 7.723 51.741 29.418 96.251 57.598 126.082 28.18 29.831 62.216 44.819 96.048 39.815 33.833-5.004 62.024-29.195 80.274-65.893 4.264-8.573 7.947-17.818 11.002-27.601-29.164.07-58.834-2.573-92.08-24.287 47.863-14.36 76.86-36.492 101.926-60.243a271.619 271.619 0 0 0-2.565-25.173c-7.723-51.741-29.416-96.253-57.596-126.084-24.657-26.103-53.8-40.838-83.365-40.762zm244.189 97.467l-87.937 109.81c-.11.17-17.645 28.102-14.198 42.682 1.549 6.554 7.56 14.287 14.304 14.287 6.744 0 12.758-7.733 14.307-14.287 3.426-14.494-13.853-42.137-14.238-42.75l8.82 5.222 128.162 75.854 59.686-74.506zm1.06 27.468l69.85 74.6H322.047zm-133.21 2.33l13.13 12.311c-17.393 18.552-47.5 23.81-71.523 21.414l1.787-17.912c19.327 1.927 45.889-4.382 56.605-15.813z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '17',
    value: BI.BiSolidDrink,
    name: 'SolidDrink',
    svgPaths: [
      'M20.832 4.555A1 1 0 0 0 20 3H4a1 1 0 0 0-.832 1.554L11 16.303V20H8v2h8v-2h-3v-3.697l7.832-11.748zm-2.7.445-2 3H7.868l-2-3h12.264z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '18',
    value: FA.FaBeer,
    name: 'Beer',
    svgPaths: [
      'M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '19',
    value: IO.IoIosBeer,
    name: 'Beer2',
    svgPaths: [
      'M112 162c0-13.3 10.7-24 24-24h229.5c4.9 0 9.6 1.5 13.5 4.4 2 1.5 4.9 0 4.8-2.5-.1-5.7-.2-9.3-.2-21.6 0-20.8-17.2-38.3-38.1-38.3h-.2c-5.7-.4-10.8-4-12.9-9.3-9-22.6-32.3-38.6-56.4-38.6-21 0-34.2 7-44 18.3-4.4 5-11.8 5.9-17.4 2.4-7.3-4.6-16.1-7.1-25.5-7.1-14.4 0-27.2 7.1-35.8 17.4-4 4.9-10.4 7-16.6 5.9-5.2-1-12.6-1.8-22.7-1.8-25 0-50 16.6-50 42.4v4c0 28.8 16 22.9 16 41.8v50.8c0 13.4-11.2 19.3-11.2 35.2 0 8.8 8 16.8 16.8 16.8H112V162zM386 452H110c-7.7 0-14 6.3-14 14s6.3 14 14 14h276c7.7 0 14-6.3 14-14s-6.3-14-14-14z',
      'M400 194h-32v-24c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v213.8c0 12.1-1.1 18.2-3.2 30.1l-.1.5c-.8 4.7.2 9.5 2.8 13.5 3.4 5.1 9.1 8.2 15.3 8.2h213.9c4.1 0 8.1-1.4 11.1-4.1 4.7-4.1 6.5-10.3 5.2-16-2.7-11.8-4.5-17.8-4.8-29.9H400c26.4 0 48-21.6 48-48v-96c0-26.5-21.6-48.1-48-48.1zm20 144c0 11-9 20-20 20h-32V222h32c11 0 20 9 20 20v96z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '20',
    value: GI.GiBeerBottle,
    name: 'BeerBottle',
    svgPaths: [
      'M200 23v18h21.895l-14.31 123.303c-14.473 8.144-25.962 16.414-34.18 25.265-9.02 9.712-14.405 20.57-14.405 31.97V445.54c0 11.4 5.042 21.877 12.348 29.794 7.305 7.917 17.208 13.666 28.35 13.666H312c11.23 0 21.24-5.72 28.596-13.645C347.953 467.432 353 456.94 353 445.54v-224c0-11.402-5.386-22.26-14.404-31.972-8.22-8.85-19.708-17.12-34.18-25.265L290.106 41H312V23H200zm40.016 18h31.968l8.094 69.727c-2.328-.97-4.98-1.573-8.078-1.573-10.342 0-17.062 6.425-22.15 10.772-5.09 4.346-5.982 7.135-9.85 6.46-4.685-.82-6.447-6.444-8.57-11.41L240.016 41zm31.25 86.113c.235.003.48.016.734.04 5.087.508 7.665 5.963 11.2 10.476l1.212 10.438a9.6 10.338 0 0 0-9.213-7.453 9.6 10.338 0 0 0-9.6 10.338 9.6 10.338 0 0 0 9.6 10.338 9.6 10.338 0 0 0 9.585-10.01l2.817 24.265 4.13 2.225c15.45 8.318 26.69 16.527 33.672 24.046 6.982 7.52 9.596 13.893 9.596 19.723v42.69h-25.568A64 94.77 0 0 0 256 221.54a64 94.77 0 0 0-53.416 42.69H177v-42.69c0-5.83 2.614-12.204 9.596-19.724s18.223-15.728 33.672-24.046l4.13-2.225 4.047-34.856c3.09 2.163 6.88 3.695 11.555 3.695 10.237 0 16.543-6.503 21.54-10.772 4.686-4.002 6.196-6.534 9.726-6.5zM256 166.4a9.6 10.338 0 0 0-9.6 10.338 9.6 10.338 0 0 0 9.6 10.338 9.6 10.338 0 0 0 9.6-10.338A9.6 10.338 0 0 0 256 166.4zm19.2 15.57a9.6 10.338 0 0 0-9.6 10.337 9.6 10.338 0 0 0 9.6 10.338 9.6 10.338 0 0 0 9.6-10.338 9.6 10.338 0 0 0-9.6-10.338zM256 247c13.42 0 23.9 9.857 30.578 22.445 1.962 3.698 3.663 7.726 5.098 12.016H336v18h-40.156c.757 5.4 1.156 11.038 1.156 16.85 0 12.354-1.775 23.944-5.06 34.075H336v18h-52.535c-6.64 9.987-15.97 17.23-27.465 17.23-11.496 0-20.825-7.243-27.465-17.23H176v-18h44.06c-3.285-10.13-5.06-21.72-5.06-34.076 0-5.812.4-11.45 1.156-16.85H176v-18h44.324c1.435-4.29 3.136-8.317 5.098-12.015C232.102 256.857 242.58 247 256 247zm0 18c-4.253 0-9.775 3.644-14.678 12.883-4.902 9.24-8.322 23.063-8.322 38.426 0 15.362 3.42 29.183 8.322 38.422 4.903 9.24 10.425 12.883 14.678 12.883s9.775-3.643 14.678-12.883c4.902-9.24 8.322-23.06 8.322-38.423 0-15.364-3.42-29.188-8.322-38.427C265.775 268.643 260.253 265 256 265zm-79 120.615h35.47a64 94.77 0 0 0 43.53 25.46 64 94.77 0 0 0 43.572-25.46H335v59.924c0 5.83-2.953 12.567-7.596 17.567-4.643 5-10.635 7.893-15.404 7.893H199.697c-4.555 0-10.502-2.867-15.12-7.873-4.62-5.006-7.577-11.758-7.577-17.588v-59.925z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '21',
    value: PI.PiFish,
    name: 'Fish',
    svgPaths: [
      'M8,175.87l56.07,16.06,16,56.07,24-56.07C242.67,188.64,225.91,67.85,220.27,41.85a8,8,0,0,0-6.13-6.13c-26-5.63-146.74-22.37-150.07,116.15Z',
      'M185.82,167.62A44,44,0,0,1,136.2,119.8,44,44,0,0,1,88.38,70.21'
    ],
    svgViewboxSize: 256,
    type: IconLineType.FILL
  },
  {
    id: '22',
    value: IO.IoIosRestaurant,
    name: 'Restaurant',
    svgPaths: [
      'M357.57,223.94a79.48,79.48,0,0,0,56.58-23.44l77-76.95c6.09-6.09,6.65-16,.85-22.39a16,16,0,0,0-23.17-.56L400.2,169.18a12.29,12.29,0,0,1-17.37,0c-4.79-4.78-4.53-12.86.25-17.64l68.33-68.33a16,16,0,0,0-.56-23.16A15.62,15.62,0,0,0,440.27,56a16.71,16.71,0,0,0-11.81,4.9l-68.27,68.26a12.29,12.29,0,0,1-17.37,0c-4.78-4.78-4.53-12.86.25-17.64L411.4,43.21a16,16,0,0,0-.56-23.16A15.62,15.62,0,0,0,400.26,16a16.73,16.73,0,0,0-11.81,4.9L311.5,97.85a79.49,79.49,0,0,0-23.44,56.59v8.23A16,16,0,0,1,283.37,174l-35.61,35.62a4,4,0,0,1-5.66,0L68.82,36.33a16,16,0,0,0-22.58-.06C31.09,51.28,23,72.47,23,97.54c-.1,41.4,21.66,89,56.79,124.08l85.45,85.45A64.79,64.79,0,0,0,211,326a64,64,0,0,0,16.21-2.08,16.24,16.24,0,0,1,4.07-.53,15.93,15.93,0,0,1,10.83,4.25l11.39,10.52a16.12,16.12,0,0,1,4.6,11.23v5.54a47.73,47.73,0,0,0,13.77,33.65l90.05,91.57.09.1a53.29,53.29,0,0,0,75.36-75.37L302.39,269.9a4,4,0,0,1,0-5.66L338,228.63a16,16,0,0,1,11.32-4.69Z',
      'M211,358a97.32,97.32,0,0,1-68.36-28.25l-13.86-13.86a8,8,0,0,0-11.3,0l-85,84.56c-15.15,15.15-20.56,37.45-13.06,59.29a30.63,30.63,0,0,0,1.49,3.6C31,484,50.58,496,72,496a55.68,55.68,0,0,0,39.64-16.44L225,365.66a4.69,4.69,0,0,0,1.32-3.72l0-.26a4.63,4.63,0,0,0-5.15-4.27A97.09,97.09,0,0,1,211,358Z'
    ],
    svgViewboxSize: 512,
    type: IconLineType.FILL
  },
  {
    id: '23',
    value: MD.MdOutlineCookie,
    name: 'Cookie',
    svgPaths: [
      'M21.95,10.99c-1.79-0.03-3.7-1.95-2.68-4.22c-2.98,1-5.77-1.59-5.19-4.56C6.95,0.71,2,6.58,2,12c0,5.52,4.48,10,10,10 C17.89,22,22.54,16.92,21.95,10.99z M8.5,15C7.67,15,7,14.33,7,13.5S7.67,12,8.5,12s1.5,0.67,1.5,1.5S9.33,15,8.5,15z M10.5,10 C9.67,10,9,9.33,9,8.5S9.67,7,10.5,7S12,7.67,12,8.5S11.33,10,10.5,10z M15,16c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1s1,0.45,1,1 C16,15.55,15.55,16,15,16z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '24',
    value: PI.PiCookingPot,
    name: 'Camp cook',
    svgPaths: ['M48,80H208a8,8,0,0,1,8,8v96a24,24,0,0,1-24,24H64a24,24,0,0,1-24-24V88A8,8,0,0,1,48,80Z'],
    svgViewboxSize: 256,
    type: IconLineType.FILL
  },
  {
    id: '25',
    value: TB.TbChefHat,
    name: 'Chef',
    svgPaths: [
      'M12 3c1.918 0 3.52 1.35 3.91 3.151a4 4 0 0 1 2.09 7.723l0 7.126h-12v-7.126a4 4 0 1 1 2.092 -7.723a4 4 0 0 1 3.908 -3.151z',
      'M6.161 17.009l11.839 -.009'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '26',
    value: PI.PiPizza,
    name: 'Pizza',
    svgPaths: [
      'M12 21.5c-3.04 0 -5.952 -.714 -8.5 -1.983l8.5 -16.517l8.5 16.517a19.09 19.09 0 0 1 -8.5 1.983z',
      'M5.38 15.866a14.94 14.94 0 0 0 6.815 1.634a14.944 14.944 0 0 0 6.502 -1.479',
      'M13 11.01v-.01',
      'M11 14v-.01'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '27',
    value: BI.BiSolidDrink,
    name: 'Drink',
    svgPaths: [
      'M20.832 4.555A1 1 0 0 0 20 3H4a1 1 0 0 0-.832 1.554L11 16.303V20H8v2h8v-2h-3v-3.697l7.832-11.748zm-2.7.445-2 3H7.868l-2-3h12.264z'
    ],
    svgViewboxSize: 24,
    type: IconLineType.FILL
  },
  {
    id: '28',
    value: PI.PiBeerBottle,
    name: 'Wine',
    svgPaths: [
      'M216,24,152,72l-40,8L28.69,163.31a16,16,0,0,0,0,22.63l41.37,41.37a16,16,0,0,0,22.63,0L176,144l8-40,48-64'
    ],
    svgViewboxSize: 254,
    type: IconLineType.FILL
  }
];

export const colorArray: DropdownOption[] = [
  {
    id: 1,
    value: `#00cc76`,
    name: ''
  },
  {
    id: 2,
    value: `#c73931`,
    name: ''
  },
  {
    id: 3,
    value: `#f04c42`,
    name: ''
  },
  {
    id: 4,
    value: `#9f5ab3`,
    name: ''
  },
  {
    id: 5,
    value: `#9245aa`,
    name: ''
  },
  {
    id: 6,
    value: `#0080b6`,
    name: ''
  },
  {
    id: 7,
    value: `#0098d8`,
    name: ''
  },
  {
    id: 8,
    value: `#00bc9d`,
    name: ''
  },
  {
    id: 9,
    value: `#00a085`,
    name: ''
  },
  {
    id: 10,
    value: `#00ae64`,
    name: ''
  },
  {
    id: 11,
    value: `#5876a3`,
    name: ''
  },
  {
    id: 12,
    value: `#f6c435`,
    name: ''
  },
  {
    id: 13,
    value: `#fa9c30`,
    name: ''
  },
  {
    id: 14,
    value: `#ee7e32`,
    name: ''
  },
  {
    id: 15,
    value: `#db541b`,
    name: ''
  },
  {
    id: 16,
    value: `#ffffff`,
    name: ''
  },
  {
    id: 17,
    value: `#CCCCCC`,
    name: ''
  },
  {
    id: 18,
    value: `#93a5a6`,
    name: ''
  },
  {
    id: 19,
    value: `#7e8c8d`,
    name: ''
  },
  {
    id: 20,
    value: `#000000`,
    name: ''
  },
  {
    id: 21,
    value: `#323232`,
    name: ''
  },
  {
    id: 22,
    value: `#0070d2`,
    name: ''
  },
  {
    id: 23,
    value: `#EB99B3`,
    name: ''
  },
  {
    id: 24,
    value: `#71ADDA`,
    name: ''
  }
];

export const DEFAULT_WHITE_COLOR_ARRAY_OPTION = colorArray[15];
